module.exports = __webpack_public_path__ + "img/hk.c8b34168.svg";